/**
 * Пути в одном месте: строки маршрутов не разъезжаются между роутером,
 * навигацией и тестами.
 */
export const ROUTES = {
  home: '/',
  matches: '/matches',
  derby: '/derby',
  career: '/career',
  draws: '/draws',
  rating: '/rating',
  profile: '/profile',
  authError: '/auth-error',
} as const;

export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES];
